import axios from 'axios';

import { toCamelCaseRecursive } from '@sv-support-sdk/utils/src/helpers/string';

const defaultHeaders = {
  'Content-Type': 'application/json',
};

interface ISetupApiProps {
  baseURL: string;
  headers?: { [key: string]: any };
  withCredentials?: boolean;
}

export const setupApiInstance = ({ baseURL, headers = defaultHeaders, withCredentials = false }: ISetupApiProps) => {
  const instance = axios.create({
    baseURL,
    headers,
    withCredentials,
  });

  instance.interceptors.response.use(
    (response) => {
      if (response?.data?.code === 400) {
        return Promise.reject(response.data);
      }

      if (response?.data?.errors && !response?.data?.ok) {
        return Promise.reject({ message: response.data.errors });
      }

      return Promise.resolve(toCamelCaseRecursive(response.data));
    },
    (error) => Promise.reject(error),
  );

  return instance;
};
